import { getParentId } from "seneca-common/features/course/selectors/content";
import { hasContentStat } from "seneca-common/features/stats/state";

import { getContentId } from "./state/sessionModules";

export {
  getSessionModules,
  getModule as getSessionModule,
  getContentModuleId,
  getContentId,
  getModuleType,
  getContent,
  getTestingActive,
  getTimeStarted,
  getTimeFinished,
  getModuleState,
  getCompleted,
  getSubmitted,
  getGaveUp,
  getUserAnswer,
  getScore,
  wasCorrect,
  wasIncorrect,
  moduleStillInProgress,
  createScoreSelector,
  getNumberOfSessionModules,
  getNumberOfCorrectSessionModules,
  getNumberDistinctModulesWithGif
} from "./state/sessionModules";

export function getNotSeenBefore(
  state: any,
  sessionId: string,
  sessionModuleId: string
): boolean {
  const contentId = getContentId(state, sessionId, sessionModuleId);
  return !hasContentStat(state, contentId);
}

export function getContentParentId(
  state: any,
  sessionId: string,
  sessionModuleId: string
) {
  const contentId = getContentId(state, sessionId, sessionModuleId);
  return getParentId(state, contentId);
}
